import React from "react"
import {TextTag as Text } from "../../atoms"

const ViewTotal = (props) => {
  const { name, price } = props;
  
  return (
    price != '0.00' ?
    <section className ="view-total">
      <Text textType="sectionHeading" className="total_text">{ name }</Text>
      <Text textType="sectionHeading" className="totol_price">{ `$${price}` }</Text>
    </section>
    : null
  )
}

export default ViewTotal;

